import React, { useEffect } from "react";
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import { useTranslation } from "react-i18next";
import { Card, CardContent, CardHeader, Divider, Grid, Toolbar, Alert, TextField, } from "@mui/material";
import Box from "@mui/material/Box";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
// import PlanningSummary from "./PlanningSummary";
// import PlanningSend from "./ApprovedSend";
import DoneIcon from "@mui/icons-material/Done";
import { ReactComponent as SendIcon } from "../../assets/images/send.svg";
import { ReactComponent as BtnX } from "../../assets/images/plus-circle-fill.svg";
import planningService from "../../services/planning.service";
import DialogSend from "../../components/DialogSend";
import ConfirmDialog from "../../components/ConfirmDialog";
import MessageDialog from "../../components/inbox/MessageDialog";
import SimpleDialog from "../../components/SimpleDialog";
import { useDispatch, useSelector } from "react-redux";
import { fetchPlanning } from "../../actions/planning";
import bannerBg from "../../assets/images/congratulation/bg-green.svg";
import needIcon from "../../assets/images/congratulation/need.svg";
import badIcon from "../../assets/images/congratulation/bad.svg";
import soIcon from "../../assets/images/congratulation/so.svg";
import greatIcon from "../../assets/images/congratulation/great.svg";
import loveIcon from "../../assets/images/congratulation/love.svg";
import { ReactComponent as StarIcon } from "../../assets/images/congratulation/star.svg";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { useParams, useNavigate } from "react-router-dom";
import evaluateService from "../../services/evaluate.service";
import { makeStyles, styled } from "@mui/styles";
import { ReactComponent as ApprovedIcon } from "../../assets/images/iconStatus/approved.svg";
import ConfirmRejectPerformanceEvaliation from "../../views/app/kpi/ConfirmRejectPerformanceEvaliation";
import * as Util from "../../services/global.service";

const styles = {
    paperContainer: {
        backgroundImage: `url(${bannerBg})`,
        width: "100%",
        maxHeight: "100%",
        height: "250px",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        position: "relative",
    },
    icon: {
        position: "absolute",
        bottom: "-23%",
        margin: "0 auto",
        left: 0,
        right: 0
    },
};

function SendToApprove(props) {
    const { t } = useTranslation()
    const planning = props.data;
    const { onClose, serial, statusSend } = props;
    const [openFailedMessageDialog, setFailedMessageDialog] = React.useState(false);
    const [errorText, seterrorText] = React.useState("");
    const [isSuccessSaveDialogOpen, openSuccessSaveDialog] = React.useState(false);
    const [datasError, setDatasError] = React.useState([]);
    const [sendWranning, setSendWranning] = React.useState([]);
    const [values, setValues] = React.useState("");
    const navigate = useNavigate();
    const useStyles = makeStyles({
        firework: {

            "& .firework": {
                position: "absolute",
                "border-radius": "50%",
                width: "7.5px",
                height: "7.5px",
            },
            "& .firework1": {
                animation: `$firework-sm 1.2s both infinite`,
                "animation-delay": "0.7s",
                top: "25%",
                left: "10%",
            },
            "& .firework2": {
                animation: `$firework-md 1.2s both infinite`,
                "animation-delay": "0.4s",
                top: "35%",
                left: "85%",
            },
            "& .firework3": {
                animation: `$firework-lg 1.2s both infinite`,
                "animation-delay": "1.1s",
                top: "50%",
                left: "40%",
            },
        },
        "@keyframes firework-sm": {
            "0%, 100%": {
                opacity: 0,
            },
            "10%, 70%": {
                opacity: 1,
            },
            "100%": {
                "box-shadow": "-30px 0rem 0 #fff, 30px 0rem 0 #fff, 0rem -30px 0 #fff, 0rem 30px 0 #fff, 20px -20px 0 #fff, 20px 20px 0 #fff, -20px -20px 0 #fff, -20px 20px 0 #fff",
            },
        },
        "@keyframes firework-md": {
            "0%, 100%": {
                opacity: 0,
            },
            "10%, 70%": {
                opacity: 1,
            },
            "100%": {
                "box-shadow": "-45px 0rem 0 #fff, 45px 0rem 0 #fff, 0rem -45px 0 #fff, 0rem 45px 0 #fff, 30px -30px 0 #fff, 30px 30px 0 #fff, -30px -30px 0 #fff, -30px 30px 0 #fff",
            },
        },
        "@keyframes firework-lg": {
            "0%, 100%": {
                opacity: 0,
            },
            "10%, 70%": {
                opacity: 1,
            },
            "100%": {
                "box-shadow": "-60px 0rem 0 #fff, 60px 0rem 0 #fff, 0rem -60px 0 #fff, 0rem 60px 0 #fff, 40px -40px 0 #fff, 40px 40px 0 #fff, -40px -40px 0 #fff, -40px 40px 0 #fff",
            },
        },
        boxIcon: {
            backgroundColor: "#ffffff",
            borderRadius: "50%",
            width: "40px",
            height: "40px",
            "box-shadow": "0px 4px 4px rgba(0, 0, 0, 0.15)",
            border: "none",
            transition: "0.5s",
            cursor: "pointer",
            margin: "0 20px",
            "&:hover": {
                transition: "0.5s",
                animation: `$shadow 1.2s infinite`,
                transform: "scale(1.2)",
            },
        },
        "@keyframes shadow": {
            // "0%": {
            //     "box-shadow": "5px 5px 10px rgb(93, 161, 150),-5px -5px 20px rgb(93, 161, 150)"
            // },
            // "50%": {
            //     "box-shadow": "5px 5px 10px rgb(81, 224, 210),- 5px - 5px 20px rgb(81, 224, 210)"
            // },
            // "100%": {
            //     "box-shadow": "5px 5px 10px rgb(93, 161, 150),- 5px - 5px 20px rgb(93, 161, 150)"
            // },
            "0%": {
                "box-shadow": " 0 0 0 0px rgba(93, 161, 150, 0.8)"
            },
            "100%": {
                "box-shadow": " 0px 0px 10px rgba(93, 161, 150, 0.5)"
            }
        },
    })
    const classes = useStyles();
    const handleClose = () => {
        onClose();
    };

    const dispatch = useDispatch();
    let remark = ""
    useEffect(() => {
    }, []);
    const handleChange = (event) => {

    };
    const BootstrapTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} arrow classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.arrow}`]: {
            color: "#343A40",
        },
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: "#343A40",
            color: "#FFFFFF",
            padding: "11px 15px",
        },
    }));

    return (
        <Grid item lg={12} md={12}>
            <Grid item container>
                <Box sx={{ backgroundColor: "#ffffff", width: "100%" }}>
                    <Box sx={{ position: "relative" }} className={`${classes.firework}`}>
                        <img src={bannerBg} alt="" style={{ maxWidth: "100%" }} />
                        <Box className="firework firework1"></Box>
                        <Box className="firework firework2"></Box>
                        <Box className="firework firework3"></Box>
                        <StarIcon style={styles.icon} />
                    </Box>
                    <Box sx={{ display: "flex", flexFlow: "column", justifyContent: "center", alignItems: "center", paddingTop: "75px", width: "100%" }}>
                        <Typography fontSize={40} lineHeight="59.8px" fontWeight={600} >CONGRATULATIONS!</Typography>
                        <Typography fontSize={18} lineHeight="26.91px" fontWeight={400} pt={2} pb={1} >You’ve completed the annual performance appraisal 2021-2022.</Typography>
                        <Button onClick={handleClose} size="medium" variant="contained" sx={{ width: '250px', color: "#fff!important", fontSize: '18px', lineHeight: '19.8px', paddingTop: '10px', paddingBottom: '10px', margin: "20px 0" }} >Close</Button>
                        <Typography fontSize={16} lineHeight="23.92px" fontWeight={400} pb={4}
                            sx={{ textDecoration: "underline", cursor: "pointer", '&:hover': { color: 'rgb(65, 112, 105) !important' }, transition: "color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms", }} color="primary"
                            onClick={e => navigate(`/kpi/evaluation`, { replace: false })}>
                            Back to My Evaluation
                        </Typography>
                    </Box>
                </Box>
                <Box sx={{ backgroundColor: "#F5F5F5", width: "100%", "box-shadow": "inset 0px 4px 5px rgba(0, 0, 0, 0.05)" }}>
                    <Box sx={{ display: "flex", flexFlow: "column", justifyContent: "center", alignItems: "center", paddingTop: "25px", width: "100%" }}>
                        <Typography fontSize={18} lineHeight="26.91px" fontWeight={500} >How was your evaluation experience with IPOP? </Typography>
                        <Typography fontSize={14} lineHeight="20.93px" fontWeight={400} pt="5px" sx={{ color: "#939393" }} >We are enger to hear your feedback to improve this tool.</Typography>
                        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "20px 0px" }}>
                            <BootstrapTooltip title={`Need to improve`} placement="top">
                                <Box className={`${classes.boxIcon}`}>
                                    <img src={needIcon} alt=""></img>
                                </Box>
                            </BootstrapTooltip>
                            <BootstrapTooltip title={`Bad`} placement="top">
                                <Box className={`${classes.boxIcon}`}>
                                    <img src={badIcon} alt=""></img>
                                </Box>
                            </BootstrapTooltip>
                            <BootstrapTooltip title={`So so`} placement="top">
                                <Box className={`${classes.boxIcon}`}>
                                    <img src={soIcon} alt=""></img>
                                </Box>
                            </BootstrapTooltip>
                            <BootstrapTooltip title={`Great`} placement="top">
                                <Box className={`${classes.boxIcon}`}>
                                    <img src={greatIcon} alt=""></img>
                                </Box>
                            </BootstrapTooltip>
                            <BootstrapTooltip title={`In love`} placement="top">
                                <Box className={`${classes.boxIcon}`}>
                                    <img src={loveIcon} alt=""></img>
                                </Box>
                            </BootstrapTooltip>
                        </Box>
                        <Box sx={{ maxWidth: "500px", width: "100%" }}>
                            <TextField
                                fullWidth
                                name="comment"
                                placeholder="Please leave your comment."
                                onChange={handleChange}
                                value={values}
                                variant="outlined"
                                multiline
                                rows={2}
                            />
                        </Box>
                        <Typography fontSize={10} lineHeight="14.95px" fontWeight={400} variant="sub_label" pt="10px" pb="15px">Character design by <span style={{ color: "#939393", fontWeight: "500" }}>SODA</span></Typography>
                    </Box>
                </Box>

            </Grid>
        </Grid>
    );
}
function SimpleDialogS(props) {
    const { onClose, selectedValue, sendData, open, serial } = props;
    const handleClose = () => {
        onClose(selectedValue);
    };
    const handleListItemClick = (value) => {
        onClose(value);
    };
    const statusSend = () => {
        sendData()
    }
    // const failed = () => {
    //     fail()
    // }
    return (
        <Dialog onBackdropClick={() => { return false }} onClose={handleClose} open={open} maxWidth='md' fullWidth sx={{ '.MuiPaper-root': { "maxWidth": "780px", borderRadius: "25px" } }}>
            <SendToApprove onClose={handleListItemClick} serial={serial} statusSend={statusSend} />
        </Dialog>
    );
}
SimpleDialogS.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    selectedValue: PropTypes.string.isRequired,
};
export default function DialogSendToApprove(props) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [open, setOpen] = React.useState(false);
    const { submitError, serial, textWarning, can_submit, serialEva, nameButton, iconApprove, type, is360 } = props;
    console.log('submitError', submitError)
    const [openFailedMessageDialog, setFailedMessageDialog] = React.useState(false);
    const [errorText, seterrorText] = React.useState("");
    const [isSuccessSaveDialogOpen, openSuccessSaveDialog] = React.useState(false);
    const [openConfirmApprovePerformanceEvaliation, setOpenConfirmApprovePerformanceEvaliation] = React.useState(false);
    const dispatch = useDispatch();
    const handleClickSubmit = (data) => {
        setOpenConfirmApprovePerformanceEvaliation(false)
        console.log(is360);
        if (is360) {
            evaluateService.submitForm360({
                form_evaluate_id: serial,
            }).then(
                (response) => {
                    openSuccessAddDialog(true)
                },
            ).catch(() => {
                seterrorText(t(`admin.label.GoalCategoryCreatedFail`))
                handleOpenFailedMessageDialog(true)
            })
        } else {
            evaluateService.submitForm({
                evaluate_id: serial,
                remark: Util.formatData(data?.description, "")
            }).then(
                (response) => {
                    openSuccessAddDialog(true)
                },
            ).catch(() => {
                seterrorText(t(`admin.label.GoalCategoryCreatedFail`))
                handleOpenFailedMessageDialog(true)
            })
        }
    };
    const handleClose = (value) => {
        setOpen(false);
    };
    const handleOpenFailedMessageDialog = (value) => {
        setFailedMessageDialog(true);
    };
    const handleCloseFailedMessageDialog = (value) => {
        setFailedMessageDialog(false);
    };
    const [discardDialog, setDiscardDialog] = React.useState(false);
    const handleDiscardDialog = (value) => {
        setDiscardDialog(value)
    };
    const handleDiscardChangeConfirm = () => {
        handleDiscardDialog(false)
        handleClickSubmit()
    };
    const [isSuccessAddDialogOpen, openSuccessAddDialog] = React.useState(false);
    const handleDirect = () => {
        openSuccessAddDialog(false)
    }
    const handleCancel = () => {
        if (type === 'approve') {
            setOpenConfirmApprovePerformanceEvaliation(true)
        } else {
            setDiscardDialog(true)
        }
    }
    const sendData = () => {
        // openSuccessSaveDialog(true)
        setOpen(false);
    }
    const handleBackToDetail = () => {
        props.loadDataDetail(false)
        if (props?.setActSave !== null && props?.setActSave !== undefined) {
            props.setActSave(false)
        }
        openSuccessAddDialog(false)
    };
    // const fail = () => {
    //     handleCloseFailedMessageDialog(true)
    //     setOpen(false);
    // }
    // const setValue = () => {
    //     openSuccessSaveDialog(false)
    // }
    return (
        <div>
            {submitError === false && can_submit === true ?
                <Button startIcon={iconApprove === true ? <ApprovedIcon /> : <SendIcon />} size="medium" variant="contained" onClick={handleCancel} sx={{ textTransform: "none", height: "45px", fontSize: "16px" }}>{nameButton}</Button>
                :
                <Button startIcon={iconApprove === true ? <ApprovedIcon /> : <SendIcon />} sx={{ cursor: "no-drop", backgroundColor: "#BABABA", pointerEvents: "none", textTransform: "none", height: "45px", fontSize: "16px" }} size="medium" variant="contained">{nameButton}</Button>
            }
            <SimpleDialogS
                open={open}
                onClose={handleClose}
                serial={serial}
                sendData={sendData}
            />
            <SimpleDialog
                open={isSuccessAddDialogOpen}
                setValue={handleBackToDetail}
                text={t('evaluation.submitSuccessfully')}
                subTitle=""
            />
            <ConfirmDialog open={discardDialog} warning={true} submit={true} twoText={true} doConfirm={() => handleDiscardChangeConfirm()} setValue={() => handleDiscardDialog(false)} title={t('evaluation.areYouSure')} text={t('evaluation.proceed')} type="approve" />
            <ConfirmRejectPerformanceEvaliation action={handleClickSubmit} open={openConfirmApprovePerformanceEvaliation} setValue={setOpenConfirmApprovePerformanceEvaliation} text="Are you sure to approve this request?" title="Confirmation of approval request" />
            <MessageDialog open={openFailedMessageDialog} setValue={handleCloseFailedMessageDialog} type="fail" title={t('dialog.label.fail')} text={errorText + t('dialog.label.tryAgain')} />
        </div>
    );
}
